import React, { useEffect, useMemo } from "react";
import { useSearchParams } from "react-router-dom";
import ConsultantInvoiceTemplate from "./ConsultantInvoiceTemplate";

export default function ConsultantInvoice() {
  const [searchParams] = useSearchParams();

  useEffect(() => {
    const prevBodyMargin = document.body.style.margin;
    const prevBodyPadding = document.body.style.padding;
    const prevBodyBackground = document.body.style.background;

    document.body.style.margin = "0";
    document.body.style.padding = "0";
    document.body.style.background = "#ffffff";
    return () => {
      document.body.style.margin = prevBodyMargin;
      document.body.style.padding = prevBodyPadding;
      document.body.style.background = prevBodyBackground;
    };
  }, []);

  const data = useMemo(() => {
    try {
      const encoded = searchParams.get("data");
      if (!encoded) return null;
      return JSON.parse(atob(decodeURIComponent(encoded)));
    } catch (err) {
      console.error("Consultant invoice decode failed:", err);
      return null;
    }
  }, [searchParams]);

  if (!data) return <div>Loading invoice...</div>;

  return (
    <div style={{ width: "1000px", height: "700px", margin: 0, padding: 0, overflow: "hidden" }}>
      <ConsultantInvoiceTemplate data={data} />
    </div>
  );
}
